import ProtectedPageLayout from './Layouts/ProtectedPageLayout/ProtectedPageLayout';
import AthletePageLayout from './Layouts/AthletePageLayout/AthletePageLayout';
import ProfilePage from './Pages/AthletePage/ProfilePage/ProfilePage';
import CalendarPage from './Pages/AthletePage/CalendarPage/CalendarPage';
import PerformancePage from './Pages/AthletePage/PerformancePage/PerformancePage';
import RaceAnalysisPage from './Pages/AthletePage/RaceAnalysisPage/RaceAnalysisPage';
import TabPageLayout from './Layouts/TabPageLayout/TabPageLayout';
import T50v2TestPage from './Pages/AthletePage/TestsPage/T50v2TestPage';
import T30v2TestPage from './Pages/AthletePage/TestsPage/T30v2TestPage';
import TrainingZonesPage from './Pages/AthletePage/TestsPage/TrainingZonesPage';
import DashboardPage from './Pages/AthletePage/DashboardPage/DashboardPage';
import CoachPageLayout from './Layouts/CoachPageLayout/CoachPageLayout';
import { Navigate } from 'react-router';
import AthleteSearchPage from './Pages/CoachPage/AthleteSearchPage/AthleteSearchPage';
import MyCoachesPage from './Pages/AthletePage/MyCoachesPage/MyCoachesPage';
import CoachProfilePage from './Pages/CoachPage/ProfilePage/CoachProfilePage';
import AdminPageLayout from './Layouts/AdminPageLayout/AdminPageLayout';
import UserSearchPage from './Pages/AdminPage/UserSearchPage/UserSearchPage';
import SecurityPage from './Pages/AdminPage/SecurityPage/SecurityPage';
import FeedbackInspection from './Pages/AdminPage/FeedbackInspectionPage/FeedbackInspectionPage';
import FeedbackPage from './Pages/FeedbackPage/FeedbackPage';
import GroupPage from './Pages/CoachPage/GroupPage/GroupPage';
import AllTestsPage from './Pages/AthletePage/TestsPage/AllTestsPage';
import T25v2TestPage from './Pages/AthletePage/TestsPage/T25v2TestPage';
import ProgramCreator from './Pages/CoachPage/ProgramCreator/ProgramCreator';
import AdminDashboardPage from './Pages/AdminPage/DashboardPage/DashboardPage';
import CoachDashboardPage from './Pages/CoachPage/DashboardPage/DashboardPage';

function isAthlete(user) {
    return user.type === 'Athlete';
}

function isCoach(user) {
    return user.type === 'Coach';
}

function isAdmin(user) {
    return user.type === 'Admin';
}

export default function ProtectedRoutes(user) {
    user.type = user.type || 'Coach'; // TODO: This is for testing purposes only - in case there is no user type.
    return [
        {
            path: '/',
            page: <ProtectedPageLayout />,
            conditions: true,
            children: [
                isAthlete(user) && {
                    path: '',
                    page: <AthletePageLayout />,
                    children: [
                        {
                            path: '',
                            page: <Navigate to={'/dashboard'} />
                        },
                        {
                            path: 'dashboard',
                            page: <DashboardPage />
                        },
                        {
                            path: 'profile',
                            page: <ProfilePage />
                        },
                        {
                            path: 'tests',
                            page: (
                                <TabPageLayout
                                    pages={[
                                        { title: 'All', path: '' },
                                        { title: '25M-400M', path: 't25' },
                                        { title: 'T30 & 50M', path: 't30' },
                                        {
                                            title: '50M - 100M - 200M - 400M',
                                            path: 't50'
                                        },
                                        { title: 'Training Zones', path: 'trainingZones' }
                                    ]}
                                />
                            ),
                            children: [
                                {
                                    path: '',
                                    page: <AllTestsPage />
                                },
                                {
                                    path: 't25',
                                    page: <T25v2TestPage />
                                },
                                {
                                    path: 't30',
                                    page: <T30v2TestPage />
                                },
                                {
                                    path: 't50',
                                    page: <T50v2TestPage />
                                },
                                {
                                    path: 'trainingZones',
                                    page: <TrainingZonesPage />
                                }
                            ]
                        },
                        {
                            path: 'calendar',
                            page: <CalendarPage />
                        },
                        {
                            path: 'performance',
                            page: <PerformancePage />
                        },
                        // {
                        //     path: 'daily-plan',
                        //     page: <DailyPlanPage />
                        // },
                        {
                            path: 'race-analysis',
                            page: <RaceAnalysisPage />
                        },
                        // {
                        //     path: 'build-your',
                        //     page: <BuildYourMacrocyclePage />
                        // }
                        {
                            path: 'mycoaches',
                            page: <MyCoachesPage />
                        },
                        {
                            path: 'feedback',
                            page: <FeedbackPage />
                        }
                    ]
                },
                isCoach(user) && {
                    path: '',
                    page: <CoachPageLayout />,
                    children: [
                        {
                            path: '',
                            page: <Navigate to={'/coach_dashboard'} />
                        },
                        {
                            path: 'coach_dashboard',
                            page: <CoachDashboardPage />
                        },
                        {
                            path: 'coach_profile',
                            page: <CoachProfilePage />
                        },
                        {
                            path: 'athletes',
                            page: <AthleteSearchPage />
                        },
                        {
                            path: 'groups',
                            page: <GroupPage />
                        },
                        {
                            path: 'programs',
                            page: <ProgramCreator />
                        },
                        {
                            path: 'athlete/:athleteId',
                            children: [
                                {
                                    path: '',
                                    page: <Navigate to={'dashboard'} />
                                },
                                {
                                    path: 'dashboard',
                                    page: <DashboardPage />
                                },
                                {
                                    path: 'profile',
                                    page: <ProfilePage />
                                },
                                {
                                    path: 'tests',
                                    page: (
                                        <TabPageLayout
                                            pages={[
                                                { title: 'All', path: '' },
                                                { title: '25M-400M', path: 't25' },
                                                { title: 'T30 & 50M', path: 't30' },
                                                {
                                                    title: '50M - 100M - 200M - 400M',
                                                    path: 't50'
                                                },
                                                { title: 'Training Zones', path: 'trainingZones' }
                                            ]}
                                        />
                                    ),
                                    children: [
                                        {
                                            path: '',
                                            page: <AllTestsPage />
                                        },
                                        {
                                            path: 't25',
                                            page: <T25v2TestPage />
                                        },
                                        {
                                            path: 't30',
                                            page: <T30v2TestPage />
                                        },
                                        {
                                            path: 't50',
                                            page: <T50v2TestPage />
                                        },
                                        {
                                            path: 'trainingZones',
                                            page: <TrainingZonesPage />
                                        }
                                    ]
                                },
                                {
                                    path: 'calendar',
                                    page: <CalendarPage />
                                },
                                {
                                    path: 'performance',
                                    page: <PerformancePage />
                                },
                                {
                                    path: 'race-analysis',
                                    page: <RaceAnalysisPage />
                                }
                            ]
                        },
                        {
                            path: 'feedback',
                            page: <FeedbackPage />
                        }
                    ]
                },
                isAdmin(user) && {
                    path: '',
                    page: <AdminPageLayout />,
                    children: [
                        {
                            path: '',
                            page: <Navigate to={'/admin_dashboard'} />
                        },
                        {
                            path: 'admin_dashboard',
                            page: <AdminDashboardPage />
                        },
                        {
                            path: 'users',
                            page: <UserSearchPage />
                        },
                        {
                            path: 'admin_security',
                            page: <SecurityPage />
                        },
                        {
                            path: 'athlete/:athleteId',
                            children: [
                                {
                                    path: '',
                                    page: <Navigate to={'dashboard'} />
                                },
                                {
                                    path: 'dashboard',
                                    page: <DashboardPage />
                                },
                                {
                                    path: 'profile',
                                    page: <ProfilePage />
                                },
                                {
                                    path: 'tests',
                                    page: (
                                        <TabPageLayout
                                            pages={[
                                                { title: 'All', path: '' },
                                                { title: '25M-400M', path: 't25' },
                                                { title: 'T30 & 50M', path: 't30' },
                                                {
                                                    title: '50M - 100M - 200M - 400M',
                                                    path: 't50'
                                                },
                                                { title: 'Training Zones', path: 'trainingZones' }
                                            ]}
                                        />
                                    ),
                                    children: [
                                        {
                                            path: '',
                                            page: <AllTestsPage />
                                        },
                                        {
                                            path: 't25',
                                            page: <T25v2TestPage />
                                        },
                                        {
                                            path: 't30',
                                            page: <T30v2TestPage />
                                        },
                                        {
                                            path: 't50',
                                            page: <T50v2TestPage />
                                        },
                                        {
                                            path: 'trainingZones',
                                            page: <TrainingZonesPage />
                                        }
                                    ]
                                },
                                {
                                    path: 'calendar',
                                    page: <CalendarPage />
                                },
                                {
                                    path: 'performance',
                                    page: <PerformancePage />
                                },
                                {
                                    path: 'race-analysis',
                                    page: <RaceAnalysisPage />
                                },
                                {
                                    path: 'mycoaches',
                                    page: <MyCoachesPage />
                                }
                            ]
                        },
                        {
                            path: 'coach/:coachId',
                            children: [
                                {
                                    path: '',
                                    page: <Navigate to={'coach_dashboard'} />
                                },
                                {
                                    path: 'coach_dashboard',
                                    page: <CoachDashboardPage />
                                },
                                {
                                    path: 'coach_profile',
                                    page: <CoachProfilePage />
                                },
                                {
                                    path: 'athletes',
                                    page: <AthleteSearchPage />
                                },
                                {
                                    path: 'groups',
                                    page: <GroupPage />
                                },
                                {
                                    path: 'programs',
                                    page: <ProgramCreator />
                                }
                            ]
                        },
                        {
                            path: 'feedback-inspection',
                            page: <FeedbackInspection />
                        },
                        {
                            path: 'feedback',
                            page: <FeedbackPage />
                        },
                        {
                            path: '*',
                            page: <div>Error</div>
                        }
                    ]
                }
            ].filter(Boolean)
        }
    ];
}
